var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.name !== '404')?_c('LangSwitch'):_vm._e(),_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"10","lg":"8"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }